module.exports = __webpack_public_path__ + "img/masked_cuidadores.93462cc8.svg";